
<button class="bdr-rad-15 btn-xxs mr-2 mb-2" *ngFor="let row of rows;" (click)="toggleSelection(row)" [ngClass]="{'btn-primary': row.selected, 'btn-primary-outline': !row.selected }">{{row.name}}</button>